const katakanaToHiragana = (src: string) => {
  return src.replace(/[\u30a1-\u30f6]/g, (match: string) => {
    const chr = match.charCodeAt(0) - 0x60
    return String.fromCharCode(chr)
  })
}

const sortFunc = (firstElement: any, secondElement: any) => {
  const firstLastKana = katakanaToHiragana(firstElement.lastKana.toString())
  const secondLastKana = katakanaToHiragana(secondElement.lastKana.toString())
  if (firstLastKana < secondLastKana) return -1
  else if (firstLastKana > secondLastKana) return 1
  return 0
}

const handleSortKana = (data: any) => {
  data.sort(sortFunc)
  return data
}

type ISomeObject = {
  [key: string]: string
}

export const handleChangeKeyCamelSet = (data: any) => {
  const dataCamelKeyArray = data.map((ele: any) => {
    const obj: ISomeObject = {}
    Object.keys(ele).forEach((key: string) => {
      const camelKey = key.replace(/_./g, str => {
        return str.charAt(1).toUpperCase()
      })

      obj[camelKey] = ele[key]
    })
    return obj
  })

  return dataCamelKeyArray
}

export const getActiveBadge = (status: string) => {
  switch (status) {
    case '1':
      return 'warning'
    case '0':
      return 'info'
    default:
      return ''
  }
}

export const getEmployeeTypeBadge = (status: string) => {
  switch (status) {
    case '1':
      return 'warning'
    case '0':
      return 'info'
    default:
      return ''
  }
}

export const handleSortStaffData = (data: any) => {
  //  スタッフ在籍中 常勤
  const activeAndFullTimeStaff = handleSortKana(
    data.filter((staff: any) => staff.active === 1 && staff.employeeType === 1)
  )

  //  スタッフ在籍中 常勤かなソート
  //  スタッフ在籍中 非常勤
  const activeAndPartTimeStaff = handleSortKana(
    data.filter((staff: any) => staff.active === 1 && staff.employeeType === 0)
  )
  //  スタッフ在籍中 非常勤かなソート

  //  スタッフ退職 常勤
  const notActiveAndFullTimeStaff = handleSortKana(
    data.filter((staff: any) => staff.active === 0 && staff.employeeType === 1)
  )
  //  スタッフ退職 常勤かなソート
  //  スタッフ退職 非常勤
  const notActiveAndPartTimeStaff = handleSortKana(
    data.filter((staff: any) => staff.active === 0 && staff.employeeType === 0)
  )
  //  スタッフ退職 非常勤かなソート

  const concatStaffData = Array.prototype.concat(
    activeAndFullTimeStaff,
    activeAndPartTimeStaff,
    notActiveAndFullTimeStaff,
    notActiveAndPartTimeStaff
  )

  return concatStaffData
}
